import type { FileResult } from '@pz/server';

export function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

type Listener = (file: FileResult) => void;
let previewListener: Listener | null = null;

/** In the demo viewer downloads are blocked, so generated files are shown in a preview instead. */
export function setFilePreviewListener(fn: Listener | null) {
  previewListener = fn;
}

export function saveFile(file: FileResult) {
  if (__DEMO__ && previewListener) {
    previewListener(file);
    return;
  }
  const bytes = base64ToBytes(file.base64);
  const blob = new Blob([bytes as BlobPart], { type: file.mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

/** UTF-8 text of a FileResult (a leading byte order mark is dropped). */
export function fileText(file: FileResult): string {
  return new TextDecoder('utf-8').decode(base64ToBytes(file.base64));
}

/**
 * Text of a file the person picked. Excel often saves CSV in Windows-1252, not UTF-8: try UTF-8 first, then the
 * Windows code page, so umlauts survive either way.
 */
export async function readTextFile(file: File): Promise<string> {
  const buf = await file.arrayBuffer();
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(buf);
  } catch {
    return new TextDecoder('windows-1252').decode(buf);
  }
}

